var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9799 1.99732C12.9551 0.972549 11.2932 0.97379 10.27 2.00009L9.48975 2.78268L13.1969 6.48979L13.9826 5.70165C15.0037 4.67751 15.0025 3.01993 13.9799 1.99732ZM2.80333 9.48914L8.7837 3.49085L12.4908 7.19796L6.51355 13.1931C6.35611 13.351 6.16545 13.4719 5.95543 13.5468L1.9865 14.9631C1.38981 15.176 0.81426 14.599 1.02872 14.0028L2.45413 10.0405C2.52865 9.83328 2.64788 9.64506 2.80333 9.48914ZM1.5 2H8.85783L7.86082 3H1.5C1.22386 3 1 2.77614 1 2.5C1 2.22386 1.22386 2 1.5 2ZM1.5 4H6.8638L5.86679 5H1.5C1.22386 5 1 4.77614 1 4.5C1 4.22386 1.22386 4 1.5 4ZM1.5 6H4.86978L3.87277 7H1.5C1.22386 7 1 6.77614 1 6.5C1 6.22386 1.22386 6 1.5 6Z",
    fill: "#323130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/draft.b8e944195c276faeaafd68713876e475.svg";
export { ForwardRef as ReactComponent };